import React from "react";
import { Link } from "react-router-dom";
import {
  Table,
  Space,
  Button,
  Popconfirm,
  Popover,
  Tag,
  List,
  message,
} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import {
  SearchRequest,
  GroupDeleteRequest,
} from "../../services/api/interfaces/ApiRequest";
import { Pagination } from "components/Pagination";

type GroupListProps = BaseListComponentProps & {
  groups: any;
  pagination: any;
  loading: boolean;

  history: any;
  searchOptions: any;

  loadGroups: (args: SearchRequest) => void;
  deleteGroup: (args: GroupDeleteRequest) => Promise<any>;
};

export default class GroupList extends ListComponent<GroupListProps> {
  static defaultProps = {
    loading: false,
  };

  tableColumns = [
    {
      title: "UUID",
      dataIndex: "uuid",
      key: "uuid",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.uuid - b.uuid,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend",
      sorter: (a: any, b: any) => a.name - b.name,
    },
    {
      title: "Species",
      dataIndex: ["public_group_species", "specie", "name"],
      key: "species",
      responsive: ["md"] as any,
      render: (text: string, record: any) => {
        const popoverContent = (
          <div style={{ height: 200, overflow: "auto" }}>
            <List
              dataSource={
                record.public_group_species
                  ?.filter((p) => p.specie)
                  .map((p) => p.specie.name) || []
              }
              renderItem={(item: any) => <List.Item>{item}</List.Item>}
              bordered
            />
          </div>
        );

        return (
          <Popover
            content={popoverContent}
            title="Species"
            trigger="hover"
            placement="bottom"
          >
            <Tag color="geekblue">
              {record.public_group_species?.length || 0}
            </Tag>
          </Popover>
        );
      },
    },
    {
      title: "Highlight",
      dataIndex: "highlight",
      key: "highlight",
      sorter: (a: any, b: any) => a.highlight - b.highlight,
      render: (text: string, record: any) => (
        <Tag color={record.highlight ? "green" : "purple"}>
          {record.highlight ? "Yes" : "No"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "action",
      align: "right",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`group/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>

          <div ref={(refs) => this.actionRefs.delete.push(refs)}>
            <Popconfirm
              title="Are you sure about deleting this group?"
              placement="topLeft"
              onConfirm={() => this.handleDelete(record.uuid)}
            >
              <Button type="dashed" shape="round" icon={<DeleteOutlined />} />
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ] as any;

  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.searchOptions.search,
      },
      options: {
        ...this.props.searchOptions.options,
      },
    };

    this.props.loadGroups(this.searchOptions);
  }

  handleDelete = async (uuid: string) => {
    const { deleteGroup } = this.props;

    await deleteGroup({
      group_uuid: uuid,
    });

    message.success("Group deleted successfully!");
  };

  render() {
    const { loading, pagination, groups, loadGroups } = this.props;

    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={groups}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadGroups)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={groups?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadGroups)
          }
        />
      </>
    );
  }
}
